"use strict";

angular.module("models").service("DamagesService", ["ApiService", function (ApiService) {
  var that = this;
  var params = {
    name: "damages",
    defaultOrder: { creationDate: -1 }
  };
  angular.extend(that, ApiService.getModelBis(params));
}]);